export const layoutConstants = {
    DRAWER_RESIZE_START: 'LAYOUT_DRAWER_RESIZE_START',
    DRAWER_RESIZE_END: 'LAYOUT_DRAWER_RESIZE_END',

    DRAWER_POSITION: 'LAYOUT_DRAWER_POSITION',
    DRAWER_TOGGLE_FULL_SCREEN: 'LAYOUT_DRAWER_TOGGLE_FULL_SCREEN',
    DRAWER_START_TOUCH_EVENT: 'DRAWER_START_TOUCH_EVENT',
};
